import styled from 'styled-components';

export const BlockSettingsWrapper = styled.div`
    padding: 0;
    margin: 10px 0px 0;
`;

export const BlockSettingDiv = styled.div`
    position: relative;
    opacity: ${(props) => (props.canvasIsEmpty ? '0.25' : '1')};
    pointer-events: ${(props) => (props.canvasIsEmpty ? 'none' : null)};
`;

export const InnerSettingsDiv = styled.div`
    opacity: ${(props) => (props.structureLocked ? '0.25' : '1')};
    pointer-events: ${(props) => (props.structureLocked ? 'none' : null)};
    margin-top: 16px;
`;

export const ControlsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 14px;
    margin-bottom: 20px;
`;

export const SelectAllWrapper = styled.div`
    display: block;
    height: 20px;
    position: relative;
    color: black;
    background-color: white;
    opacity: ${({ canvasIsEmpty }) => (canvasIsEmpty ? 0.25 : 1)};
`;

export const ButtonsWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 15px;
`;

export const Label = styled.span`
    color: ${({ theme }) => theme.colors.neutral700};
    font-weight: 700;
    font-size: 10px;
    line-height: 18px;
    letter-spacing: 1px;
    text-transform: uppercase;
    margin: ${({ margin }) => margin || '5px 0 0 0'};
`;

export const ColumnWidthWrapper = styled.div`
    margin-top: 15px;
`;

export const ColumnWidthControlsContainer = styled.div`
    margin-top: 10px;
`;
